import React, { useEffect, useState } from "react";
import { capitalizeWords } from "../Components/allFunctions";
import { CircleLoader } from "react-spinners";
import PageNotFound from "../Components/PageNotFound";
import Constants from "../Constants";
import { authFetch } from "../utils/authFetch";

const AUTH_ENDPOINT = Constants.AUTH_BASE_URL + "/api/v1";

const Profile = () => {
  const [profileData, setprofileData] = useState({
    userData: {},
    loading: false,
    error: "",
  });

  useEffect(() => {
    setprofileData((presVal) => ({ ...presVal, loading: true }));
    authFetch(`${AUTH_ENDPOINT}/me`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch profile");
        return res.json();
      })
      .then((data) => {
        setprofileData({
          loading: false,
          userData: data,
          error: "",
        });
      })
      .catch((error) => {
        setprofileData({
          loading: false,
          userData: {},
          error: error.message,
        });
        console.log(error.message);
      });
  }, []);

  const user = profileData.userData;
  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(" ");

  return (
    <>
      {profileData.loading ? (
        <div style={{ height: "100%" }} role="status">
          <CircleLoader className="LoaderSingleOrder" color="#1ca1ee" />
        </div>
      ) : profileData.error === "" && user?.email_address ? (
        <div className="profilePage">
          <div className="coverDIv"></div>

          <div className="profileDets">
            <div className="profileImg">
              <img
                className="imgAvtar"
                src="https://bootdey.com/img/Content/avatar/avatar7.png"
                alt=""
              />
            </div>
            <div className="profileInfo">
              <h2 className="NameHead">{capitalizeWords(fullName)}</h2>
              <h3>{user.email_address}</h3>
              {user.phone && <h3>{user.phone}</h3>}
              {user.super_admin && <h3>Super Admin</h3>}
            </div>
          </div>
        </div>
      ) : (
        <PageNotFound />
      )}
    </>
  );
};
export default Profile;
